"use strict";

var _require = require('../../../helpers'),
    computeCopies = _require.computeCopies;

var defaultPricePerSheet = 1;

module.exports = function (accumulator, order, product, component, options) {
  var pricePerSheet = parseFloat(options.pricePerSheet, 10) || defaultPricePerSheet;
  var copies = computeCopies(component);
  return (parseFloat(accumulator, 10) || 0) + pricePerSheet * copies;
};